import { z } from 'my-zod'
import { addOnProductSystemView } from './add-on-product-system-view'
import { rentalEquipmentMetadata } from './add-on-product-metadata'
import { polarisRentalProductAssociatedAddOnProductDisplayMode } from '../polaris-rental-product/polaris-rental-product-associated-addon-products'

export const rentalEquipmentAddOnProduct = addOnProductSystemView
  .pick({
    id: true,
    shortId: true,
    versionId: true,
    outfitterId: true,
    imageUrl: true,
    price: true,
    priceUnit: true,
    title: true,
    overview: true,
    createdDate: true,
    lastModifiedDate: true,
    deletedDate: true,
    taxPolicyIds: true
  })
  // .merge(rentalEquipmentMetadata)
  .augment({
    title: z
      .string()
      .min(1, 'Required')
      .refine((val) => !!val.trim(), 'Required'),
    price: z.number().min(0, 'Required'),
    overview: z.string().min(1, 'Required'),
    products: z
      .object({
        productId: z.string().min(1, 'Required'),
        maxQuantityPerRider: z.number().nullable(),
        minQuantityPerOrder: z.number().nullable(),
        displayMode: z.enum(polarisRentalProductAssociatedAddOnProductDisplayMode)
      })
      .array(),
    type: z.literal('RentalEquipment')
  })

export const rentalEquipmentAddOnProductWithPolarisRentalAssociation = rentalEquipmentAddOnProduct
  .omit({ products: true })
  .extend({
    maxQuantityPerRider: z.number().nullable(),
    minQuantityPerOrder: z.number().nullable(),
    displayMode: z.enum(polarisRentalProductAssociatedAddOnProductDisplayMode)
  })

export type rentalEquipmentAddOnProduct = z.infer<typeof rentalEquipmentAddOnProduct>
export type rentalEquipmentAddOnProductWithPolarisRentalAssociation = z.infer<
  typeof rentalEquipmentAddOnProductWithPolarisRentalAssociation
>
